import { PlayerCard as PlayerCardComponent } from './PlayerCard.component';
import { connector } from './PlayerCard.connector';
export const PlayerCard = connector(PlayerCardComponent);
